import {
  checkLogin,
  auth,
  twoStep,
  authMobile,
  generateOtpCodeWt,
  changePassword,
  contactUs,
  signOut,
} from "./auth-services";

import {
  getActiveRegistrations,
  getDetailRegistrations,
  sendMobile,
  confirmMobile,
  confirmRegistrationCode,
  setPreRegister,
} from "./pre-register-services";

export {
  checkLogin,
  auth,
  twoStep,
  authMobile,
  generateOtpCodeWt,
  changePassword,
  contactUs,
  signOut,
  getActiveRegistrations,
  getDetailRegistrations,
  sendMobile,
  confirmMobile,
  confirmRegistrationCode,
  setPreRegister,
};
